export class ScheduleRenewal {
    static readonly type = '[Auth] ScheduleRenewal';
}
